const isRefInViewport = ({
  offsetScroll, refHeight, refRect, windowObj
}) => {
  return (
    (refRect.top + refHeight) >= 0
    && refRect.left >= 0
    && (refRect.bottom + offsetScroll) <= (windowObj.innerHeight)
    && refRect.right <= (windowObj.innerWidth)
  );
};

const isScrolledPastOffset = (offsetScroll, windowObj) => {
  return windowObj.pageYOffset >= offsetScroll;
};

const applyInlineOffsetMargin = (animation, offsetMargin, position, stickyType) => {
  const check = parseInt(offsetMargin, 10) && animation === 'slide' && stickyType === 'showOnScrollUp';
  if (!check) return {};
  const topStyle = check && position === 'top' ? { top: `${offsetMargin}px` } : null;
  const bottomStyle = check && position === 'bottom' ? { bottom: `${offsetMargin}px` } : null;
  return topStyle || bottomStyle || {};
};

const getTopPosition = (ref) => {
  if (!ref) return null;
  return ref.current?.getBoundingClientRect().top;
};

const getScrollPosition = (windowObj) => {
  return windowObj?.pageYOffset || document?.documentElement?.scrollTop;
};

const isScrolledPastContent = (windowObj, yPosition) => {
  return getScrollPosition(windowObj) > yPosition && yPosition > 0;
};

export {
  applyInlineOffsetMargin,
  getScrollPosition,
  getTopPosition,
  isRefInViewport,
  isScrolledPastContent,
  isScrolledPastOffset
};
